import { render } from "./CheckoutView.vue?vue&type=template&id=5278c552&scoped=true"
import script from "./CheckoutView.vue?vue&type=script&lang=js"
export * from "./CheckoutView.vue?vue&type=script&lang=js"

import "./CheckoutView.vue?vue&type=style&index=0&id=5278c552&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5278c552"]])

export default __exports__